// Accepts an easing function and returns a new one that outputs reversed values.
// Turns easeIn into easeOut.
var reverseEasing=function reverseEasing(easing){return function(p){return 1-easing(1-p);};};export{reverseEasing};